import { apiPut } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { useForm } from "react-hook-form";
import ErrorMessage from "components/ErrorMessage";
import useToastContext from "hooks/useToastContext";
import { useTranslation } from "react-i18next";

const EditFAQ = ({ setEditShowModal, getAllFAQ, item }) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      title: item?.title,
      content: item?.content,
    },
  });
  const notification = useToastContext();

  const onSubmit = async (data) => {
    try {
      data.title = data?.title?.trim();
      const path = apiPath.getFAQs + "/" + item._id;
      const result = await apiPut(path, data);
      if (result?.data?.success) {
        notification.success(result?.data?.message);
        getAllFAQ();
        setEditShowModal(false);
      } else {
        notification.error(result?.data?.message);
      }
    } catch (error) {
      console.error("error in get all faqs list==>>>>", error.message);
    }
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form onSubmit={handleSubmit(onSubmit)} className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("FAQS_EDIT_FAQS")}</h3>
                <button className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none" onClick={() => setEditShowModal(false)}>
                  <span className=" text-[#B8BBBF]  text-4xl ">×</span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <div className="grid grid-cols-1">
                  <div className="relative z-0 mb-6 w-full ">
                    <input
                      autoFocus
                      maxLength={100}
                      type="text"
                      name="title"
                      id="title"
                      className="bg-transparent border-2 rounded-lg py-4 px-3 w-full text-sm text-gray-900 border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                      {...register("title", {
                        required: "Please enter title.",
                        minLength: {
                          value: 2,
                          message: "Minimum length must be 2.",
                        },
                      })}
                    />
                    <label
                      maxLength={200}
                      htmlFor="title"
                      className="text-sm text-[#A5A5A5] dark:text-gray-400 peer-focus:font-normal absolute duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                    >
                      {t("FAQS_TITLE")}
                      <span className="text-red-500">*</span>
                    </label>
                    <ErrorMessage message={errors?.title?.message} />
                  </div>
                  <div className="z-0 mb-6 w-full group relative ">
                    <textarea
                      id="content"
                      type="textarea"
                      name="content"
                      className="text-gray-900 bg-transparent border-2 block py-4 px-3 w-full text-sm rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                      placeholder=" "
                      {...register("content", {
                        required: "Please enter content.",

                        maxLength: {
                          value: 500,
                          message: "Maximum character can be 500.",
                        },
                        minLength: {
                          value: 10,
                          message: "Minimum length must be 10.",
                        },
                      })}
                    />
                    <label
                      className="absolute text-sm text-[#A5A5A5] dark:text-gray-400 peer-focus:font-normal  duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                      htmlFor="content"
                    >
                      {t("FAQS_CONTENT")}
                      <span className="text-red-500">*</span>
                    </label>
                    <ErrorMessage message={errors?.content?.message} />
                  </div>
                </div>
              </div>
              <div className="justify-center p-6 border-t flex items-center  border-solid border-slate-200 rounded-b">
                <button className="px-12 py-2.5 text-black bg-[#E1E1E1] font-normal text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" onClick={() => setEditShowModal(false)} type="button">
                  {t("O_BACK")}
                </button>
                <button className="bg-LightBlue text-white active:bg-emerald-600 font-normal rounded shadow hover:shadow-lg outline-none text-sm px-8 py-2.5  focus:outline-none mr-1  ease-linear transition-all duration-150" type="submit">
                  {t("O_SAVE")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="fixed inset-0 opacity-25 z-40 bg-black" />
    </>
  );
};

export default EditFAQ;
